export class SmsTemplateDTO {
	constructor(
		public id?: number,
		public title?: string,
		public body?: string,
		public is_default?: boolean,
		public imagingCenterId: number = 1
	) {}
}
